var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_79","data-name":"Path 79","d":"M18.2-28.915v5.009H15.217a2.788,2.788,0,0,0-2.2.683,3.143,3.143,0,0,0-.569,2.049v3.586h5.559l-.74,5.616H12.446v14.4H6.641v-14.4H1.8v-5.616H6.641v-4.136A7.339,7.339,0,0,1,8.614-27.2a7.161,7.161,0,0,1,5.256-1.945A31.387,31.387,0,0,1,18.2-28.915Z","transform":"translate(-1.803 29.143)","fill":"#4b858e"}));
}

FacebookInline.defaultProps = {"width":"16.393","height":"31.572","viewBox":"0 0 16.393 31.572"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
